import { Component, OnInit } from '@angular/core';
import { AngularFireDatabase, FirebaseListObservable } from 'angularfire2/database-deprecated';
import { Router } from '@angular/router';
import { UserService } from '../_services/user.service';
import { MatDialog } from '@angular/material';
import { SaveMessageComponent } from '../directive/save-message/save-message.component';
import { Subscription } from 'rxjs';
import { AngularFirestore } from 'angularfire2/firestore';

@Component({
  selector: 'app-product-advice',
  templateUrl: './product-advice.component.html',
  styleUrls: ['./product-advice.component.css']
})
export class ProductAdviceComponent implements OnInit {
  productModel: any = {
    category: "Kategori Seç",
    url: "",
    type: "any"
  };
  userId = this.userService.getUid();
  categories: FirebaseListObservable<any[]>;
  user: any;
  isMobile = false;
  private subscription: Subscription = new Subscription();

  constructor(private afm: AngularFireDatabase,
    private afs: AngularFirestore,
    private router: Router,
    private userService: UserService,
    public dialog: MatDialog) {
    this.categories = afm.list('categories', {
      query: {
        orderByChild: 'parent',
        equalTo: false
      }
    });
    this.subscription.add(this.userService.getUser().subscribe(user => {
      this.user = user
    }));
    this.isMobile = window.matchMedia("(max-width: 1024px)").matches;
  }

  ngOnDestroy() {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.subscription.unsubscribe();
  }

  ngOnInit() {
  }

  changeText(string) {
    return string
      .replace(/ö/g, 'o')
      .replace(/Ö/g, 'o')
      .replace(/ç/g, 'c')
      .replace(/Ç/g, 'c')
      .replace(/ş/g, 's')
      .replace(/Ş/g, 's')
      .replace(/ı/g, 'i')
      .replace(/İ/g, 'i')
      .replace(/ğ/g, 'g')
      .replace(/Ğ/g, 'g')
      .replace(/ü/g, 'u')
      .replace(/Ü/g, 'u')
      .replace('&', '')
      .replace(/,/g, '')
      .replace(/\./g, '_')
      .replace(/\-/g, '')
      .replace(/\'/g, '')
      .replace(/\s/g, '')
      .toLowerCase();
  }

  productSubmit(form) {
    if (!this.userId) {
      this.router.navigate(['/auth']);
      return;
    }
    let product = form.product ? this.changeText(form.product) : null;
    let brand = form.brand ? this.changeText(form.brand) : null;
    const { firstname, lastname, username, email } = this.user;
    if (form.type == "product") {
     
      if (form.category != "Kategori Seç" && form.product && form.brand && form.type != 'any') {
        this.afs.collection('userSuggestions').ref.where('name', '==', form.product).get().then((snap => {
          if (snap.empty) {
            this.afs.collection('userSuggestions').add({
              name: form.product,
              brand: form.brand,
              category: form.category,
              url: form.url,
              isSeen: false,
              type: "product",
              modifyDate: Date.now(),
              user: {
                firstname: firstname,
                lastname: lastname,
                username: username,
                email: email ? email : null
              }

            })
            this.dialog.open(SaveMessageComponent, {
              width: '500px',
              data: {
                message: "Önerin için teşekkürler! Markan tanımlandığında e-posta ile bildireceğiz.",
                type: "update"
              }
            });
          }
          else {
            this.dialog.open(SaveMessageComponent, {
              width: '400px',
              data: {
                message: "Bu Öneri Daha Önce Yapıldı! Teşekkürler :)",
                type: "update"
              }
            });
          }
        }))
      } else {
        this.dialog.open(SaveMessageComponent, {
          width: '400px',
          data: {
            message: "Lütfen formu doldur!",
            type: "update"
          }
        });
      }
    } else if (form.type == "brand") {
      if (form.category != "Kategori Seç" && form.brand && form.type != 'any') {
      
        this.afs.collection('userSuggestions').ref.where('name', '==', form.brand).get().then((snap => {
          if (snap.empty) {
            this.afs.collection('userSuggestions').add({
              name: form.brand,
              category: form.category,
              url: form.url,
              isSeen: false,
              type: "brand",
              modifyDate: Date.now(),
              user: {
                firstname: firstname,
                lastname: lastname,
                username: username,
                email: email ? email : null
              }

            })
            this.dialog.open(SaveMessageComponent, {
              width: '400px',
              data: {
                message: "Önerin için teşekkürler! Markan tanımlandığında e-posta ile bildireceğiz.",
                type: "update"
              }
            });
          }
          else {
            this.dialog.open(SaveMessageComponent, {
              width: '400px',
              data: {
                message: "Bu Öneri Daha Önce Yapıldı! Teşekkürler :)",
                type: "update"
              }
            });
          }
        }))
      } else {
        this.dialog.open(SaveMessageComponent, {
          width: '400px',
          data: {
            message: "Lütfen formu doldur!",
            type: "update"
          }
        });
      }
    }
    this.productModel = {
      category: "Kategori Seç",
      url: "",
      type: "any",
      product: "",
      brand: ""
    };
  }
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/product-advice/product-advice.component.ts